import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { RouletteHistory } from '@/components/roulette/RouletteHistory'
import { Button } from '@/components/ui'
import { useRoulette } from '@/hooks/roulette/useRoulettes'

export function RouletteHistoryPage() {
  const { t } = useTranslation()
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { data: rouletteDetails } = useRoulette(id)

  const handleBackToRoulette = () => {
    navigate('/dashboard/roulette')
  }

  const handleSpinRoulette = () => {
    if (id) {
      navigate(`/dashboard/roulette/${id}`)
    }
  }

  if (!id) {
    navigate('/dashboard/roulette')
    return null
  }

  if (!rouletteDetails) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-muted-foreground">{t('common.loading')}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-background">
      <RouletteHistory
        rouletteId={id}
        onBackToRoulette={handleBackToRoulette}
        onSpinRoulette={handleSpinRoulette}
      />

      <div className="fixed bottom-6 right-6">
        <Button
          onClick={handleBackToRoulette}
          className="w-14 h-14 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg"
          title={t('roulette.backToList')}
        >
          🎲
        </Button>
      </div>
    </div>
  )
}
